import React from 'react';

const SettingsIcon = ({ backgroundFill, fillColor, strokeColor, strokeWidth, width }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      viewBox="0 0 24 24"
      fill={backgroundFill}
      stroke={strokeColor}
      strokeWidth={strokeWidth}
      width={width}
    >
      <path d="M13.6,2.4l.4,1.8c.2.9,1.2,1.3,2,.8l1.6-.9c1.5-.9,3.2.8,2.3,2.3l-.9,1.6c-.5.8,0,1.8.8,2l1.8.4c1.7.4,1.7,2.8,0,3.2l-1.8.4c-.9.2-1.3,1.2-.8,2l.9,1.6c.9,1.5-.8,3.2-2.3,2.3l-1.6-.9c-.8-.5-1.8,0-2,.8l-.4,1.8c-.4,1.7-2.8,1.7-3.2,0l-.4-1.8c-.2-.9-1.2-1.3-2-.8l-1.6.9c-1.5.9-3.2-.8-2.3-2.3l.9-1.6c.5-.8,0-1.8-.8-2l-1.8-.4c-1.7-.4-1.7-2.8,0-3.2l1.8-.4c.9-.2,1.3-1.2.8-2l-.9-1.6c-.9-1.5.8-3.2,2.3-2.3l1.6.9c.8.5,1.8,0,2-.8l.4-1.8c.4-1.7,2.8-1.7,3.2,0Z" />
      <circle cx="12" cy="12" r="3.2" fill={fillColor} />
    </svg>
  );
};

export default SettingsIcon;
